<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row p-3">
          <div class="col-12 col-md-6 col-lg-4 col-xl-3 mb-3">
            <label>{{ $t('common_words.farm') }}: *</label>
            <br />
            <el-select
              id="farm_labor_catchs"
              clearable
              @change="showCalendar()"
              v-bind:collapse-tags="true"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm"
              size="large"
              v-model="farm_sel"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-3 col-xl-3 mb-3">
            <label>{{ $t('common_words.date') }}: *</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              class="shadow-sm date-form required-date"
              v-model="date_sel"
              type="date"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
              range-separator="-"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-xl-3">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.filter')
            }}</label
            ><br />
            <button
              class="btn btn-success custom-shadow-btn btn-filter"
              @click="validateDate"
            >
              {{ $t('common_words.generate') }}
            </button>
          </div>
        </div>
      </card>
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert.message }}
      </div>
      <card
        class="custom-shadow-card-header mt-4"
        :title="$t('sowing.prunning_capture')"
        v-if="showPruningCatch && !messageAlert"
      >
        <div class="mt-4 px-3">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="table-responsive">
              <table
                class="table table-striped table-bordered not-last-td table-data"
              >
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong>*{{ $t('common_words.allotments') }}</strong>
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong>*{{ $t('common_words.crop_variety') }}</strong>
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong>*{{ $t('sowing.reason_rejection') }} </strong>
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong
                        >*{{
                          $t('sowing.total_plants_seeds_planted_pruning')
                        }}
                        </strong
                      >
                    </th>
                    <th scope="col" class="text-center p-3 custom-header-label">
                      <strong>{{ $t('sowing.pruned_area') }} (Ha)</strong>
                    </th>
                    <th
                      v-if="!messageAlert"
                      scope="col"
                      class="text-center custom-header-label"
                      v-bind:style="{ width: '100px', marginTop: '6px' }"
                    >
                      <strong>{{ $t('common_words.options') }}</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="index in model.nPruningCatchs" :key="index">
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        @change="
                          validateArea(index - 1, model.lots_ids[index - 1])
                        "
                        style="min-width: 110px"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="large"
                        v-model="model.lots_ids[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, index) in lots"
                          class="select-primary"
                          :value="option.id"
                          :label="`${option.name} (${$t('common_words.area')} ${
                            option.area
                          }Ha)`"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        style="min-width: 110px"
                        class="select-primary custom-width-select required-cropsVarieties shadow-sm"
                        size="large"
                        v-model="model.crops_varieties_ids[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, index) in cropVarietiesCatchs"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        style="min-width: 110px"
                        class="select-primary custom-width-select required-reasonRejection shadow-sm"
                        size="large"
                        v-model="model.reason_rejection_ids[index - 1]"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="(option, index) in reasonRejections"
                          class="select-primary"
                          :value="option.id"
                          :label="option.name"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <fg-input
                        type="number"
                        min="1"
                        ref="totalPlantsSeedsPlanted"
                        style="min-width: 90px"
                        class="shadow-sm text-center mt-3 required-totalPlantsSeedsPlanted"
                        v-model.number="
                          model.total_plants_seeds_planted[index - 1]
                        "
                        name="sowing.total_plants_seeds_planted_pruning"
                        v-validate="modelValidations.total_plants_seeds_planted"
                        :error="
                          getError(
                            'sowing.total_plants_seeds_planted_pruning',
                            true,
                            index
                          )
                        "
                      >
                      </fg-input>
                    </td>
                    <td class="text-center">
                      <fg-input
                        type="number"
                        step="0.01"
                        min="1"
                        ref="sownArea"
                        @change="
                          validateArea(index - 1, model.lots_ids[index - 1])
                        "
                        style="min-width: 90px"
                        class="shadow-sm text-center mt-3"
                        v-model="model.sown_area[index - 1]"
                        name="sowing.pruned_area"
                        v-validate="modelValidations.sown_area"
                        :error="getError('sowing.pruned_area', true, index)"
                      >
                      </fg-input>
                    </td>
                    <td
                      v-if="!messageAlert"
                      class="text-center"
                      style="min-width: 90px"
                    >
                      <div class="d-flex justify-content-center mt-3">
                        <a
                          v-if="isUpdate()"
                          v-tooltip.top-center="$t('common_words.add')"
                          class="btn-warning btn-simple btn-link custom-margin-actions"
                          @click.prevent="model.nPruningCatchs++"
                        >
                          <em class="fa fa-plus custom-size-fa-actions"></em>
                        </a>
                        <a
                          v-if="model.nPruningCatchs > 1 && isDelete()"
                          v-tooltip.top-center="$t('common_words.erase')"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="handleDelete(index - 1)"
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-if="!messageAlert" class="row">
            <div class="col-6 pr-0 text-right" v-if="isCreate() || isUpdate()">
              <button
                class="btn btn-success custom-shadow-btn btn-filter m-4"
                @click="validateEveryDetail()"
              >
                {{ $t('common_words.save') }}
              </button>
            </div>
            <div class="col-6 pl-0 text-left" v-if="isDelete()">
              <button
                class="btn btn-danger custom-shadow-btn btn-filter m-4"
                @click="confirmDelete"
              >
                {{ $t('common_words.delete') }}
              </button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import i18n from 'src/i18n';
import MixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinMenu from 'src/util/mixinMenu';
import SweetAlert from 'src/class/Alerts';

export default {
  data() {
    return {
      farms: [],
      lots: [],
      cropVarieties: [],
      cropVarietiesCatchs: [],
      sowingCatch: [],
      reasonRejections: [],
      messageAlert: null,
      calendar_sel: null,
      showPruningCatch: false,
      isShowCalendar: false,
      farm_sel: null,
      date_sel: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      model: {
        id: null,
        pruning_catch_header_id: null,
        pruning_catch_detail_id: [],
        delete_pruning_catch_header_id: null,
        delete_pruning_catch_detail_ids: [],
        nPruningCatchs: 1,
        farm_id: null,
        user_id: null,
        date_save: null,
        lots_ids: [],
        crops_varieties_ids: [],
        reason_rejection_ids: [],
        total_plants_seeds_planted: [],
        sown_area: [],
      },
      modelValidations: {
        total_plants_seeds_planted: {
          min_value: 0,
          numeric: true,
          required: true,
        },
        sown_area: {
          min_value: 0,
          decimal: true,
          required: true,
        },
      },
    };
  },
  mixins: [MixinMasters, MixinPermissions, MixinForm, MixinMenu],
  watch: {
    '$i18n.locale': 'forceRerender',
  },
  methods: {
    validateDate() {
      if (!isset(this.farm_sel)) return this.validationInputsRequired('farm');
      else if (this.date_sel == null)
        return this.validationInputsRequired('date');
      else if (this.calendar_sel == null)
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      else {
        this.messageAlert = null;
        this.showPruningCatch = true;
        this.cleanForm();
        this.loadData();
      }
    },
    showCalendar() {
      this.messageAlert = null;
      this.isShowCalendar = true;
      this.calendar_sel = null;
      this.showPruningCatch = false;

      const element = Object.values(this.farms).find(
        (el) => el.id === this.farm_sel
      );
      if (element) {
        this.isShowCalendar = element.calendars.length > 1;
        this.calendar_sel =
          element.calendars.length > 1
            ? null
            : element.calendars.length == 1
            ? element.calendars[0].id
            : null;
      }
      this.isShowCalendar = false;
    },
    cleanForm() {
      if (this.messageAlert && !this.messageAlert.show)
        this.messageAlert = null;
      this.model.farm_id = null;
      this.model.user_id = null;
      this.model.date_save = null;
      this.model.pruning_catch_header_id = null;
      this.model.pruning_catch_detail_id = [];
      this.model.delete_pruning_catch_header_id = null;
      this.model.delete_pruning_catch_detail_ids = [];
      this.model.nPruningCatchs = 1;
      this.model.lots_ids = [];
      this.model.crops_varieties_ids = [];
      this.model.reason_rejection_ids = [];
      this.model.total_plants_seeds_planted = [];
      this.model.sown_area = [];
    },
    loadData() {
      this.showHideLoading(true);
      this.showPruningCatch = true;
      const data = {
        farm_id: this.farm_sel,
        date_save: this.date_sel,
        user_id: this.$store.state.auth.user.id,
        route: 'pruning/pruningcatch/list',
      };
      const dataSowingCatch = {
        farm_id: this.farm_sel,
        catch_type: 'Siembra',
        user_id: this.$store.state.auth.user.id,
        route: 'sowing/sowingcatch/list',
      };
      Promise.all([
        Axios.getMasters('farms/farms/lots/' + this.farm_sel),
        Axios.postMasters(dataSowingCatch),
        Axios.postMasters(data),
      ])
        .then(([responseLots, responseSowingCatch, responsePruningCatch]) => {
          let cropVarietiesCatchsIds = [];
          let sowingCatch = [];
          let cropVarietySowingCatch = [];
          let pruningCatchs = responsePruningCatch.data.data;
          this.lots = responseLots.data.data;
          sowingCatch = responseSowingCatch.data.data;

          sowingCatch.forEach((sowingHeader) => {
            sowingHeader.sowing_details.forEach((sowingDetail) => {
              cropVarietySowingCatch.push(sowingDetail.crop_variety_id);
            });
          });
          cropVarietiesCatchsIds = cropVarietySowingCatch.filter(
            (valor, indice, self) => {
              return self.indexOf(valor) === indice;
            }
          );
          this.cropVarietiesCatchs = this.cropVarieties.filter((varieties) =>
            cropVarietiesCatchsIds.some((id) => id === varieties.id)
          );
          if (isset(pruningCatchs)) {
            this.model.pruning_catch_header_id = pruningCatchs[0].id;
            this.model.farm_id = pruningCatchs[0].farm_id;
            this.model.user_id = pruningCatchs[0].user_id;
            this.model.date_save = pruningCatchs[0].date_save;
            this.model.nPruningCatchs = 0;

            pruningCatchs[0].eradicate_details.forEach((detail) => {
              this.model.pruning_catch_detail_id.push(detail.id);
              this.model.lots_ids.push(detail.lot_id);
              this.model.crops_varieties_ids.push(detail.crop_variety_id);
              this.model.reason_rejection_ids.push(detail.reason_rejection_id);
              this.model.total_plants_seeds_planted.push(
                detail.total_plants_seeds
              );
              this.model.sown_area.push(detail.area);
              this.model.nPruningCatchs++;
            });
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },
    handleDelete(index) {
      if (
        isset(this.model.lots_ids[index]) &&
        isset(this.model.crops_varieties_ids[index]) &&
        isset(this.model.reason_rejection_ids[index])
      ) {
        SweetAlert.delete(this.getDataRegisterForDelete(index)).then(
          (result) => {
            if (result.value) {
              this.registerSelectDelete(index);
            }
          }
        );
      } else {
        this.registerSelectDelete(index);
      }
    },
    getDataRegisterForDelete(index) {
      const lotId = this.model.lots_ids[index];
      const cropVarietyId = this.model.crops_varieties_ids[index];
      const reasonRejectionId = this.model.reason_rejection_ids[index];

      const lotSearch = this.lots.find((lot) => lot.id === lotId);
      const cropVarietySearch = this.cropVarieties.find(
        (cropVariety) => cropVariety.id === cropVarietyId
      );
      const reasonRejectionSearch = this.reasonRejections.find(
        (reasonRejection) => reasonRejection.id === reasonRejectionId
      );

      return `${i18n.t('common_words.allotment')}: 
        ${lotSearch.name} - ${cropVarietySearch.name} - 
        ${reasonRejectionSearch.name}`;
    },
    setDeleteEradicateCatchs(index) {
      if (isset(this.model.pruning_catch_detail_id[index])) {
        this.model.delete_pruning_catch_detail_ids.push(
          this.model.pruning_catch_detail_id[index]
        );
      }
    },
    registerSelectDelete(index) {
      this.setDeleteEradicateCatchs(index);
      this.model.pruning_catch_detail_id.splice(index, 1);
      this.model.lots_ids.splice(index, 1);
      this.model.crops_varieties_ids.splice(index, 1);
      this.model.reason_rejection_ids.splice(index, 1);
      this.model.total_plants_seeds_planted.splice(index, 1);
      this.model.sown_area.splice(index, 1);
      this.model.nPruningCatchs--;
    },
    validateEveryDetail() {
      for (let i = 0; i < this.model.nPruningCatchs; i++) {
        if (!isset(this.model.lots_ids[i]))
          return this.validationInputsRequired('lots');
        else if (!isset(this.model.crops_varieties_ids[i]))
          return this.validationInputsRequired('cropsVarieties');
        else if (!isset(this.model.reason_rejection_ids[i]))
          return this.validationInputsRequired('reasonRejection');
        else if (!isset(this.model.total_plants_seeds_planted[i]))
          return this.validationInputsRequired('totalPlantsSeedsPlanted');
      }
      this.storeUpdatePruningCatchs();
    },
    setDataByDefault() {
      this.model.farm_id = this.farm_sel;
      this.model.date_save = this.date_sel;
      this.model.user_id = this.$store.state.auth.user.id;
      for (let index = 0; index < this.model.nPruningCatchs; index++) {
        if(!isset(this.model.sown_area[index])) {
          this.$set(this.model.sown_area, index, 0);
        }        
      }
    },
    storeUpdatePruningCatchs() {
      this.setDataByDefault();
      this.showHideLoading(true);
      if (this.isCreate() || this.isUpdate()) {
        this.model.route = 'pruning/pruningcatch/store';
        if (isset(this.model.pruning_catch_header_id)) {
          this.model.route = 'pruning/pruningcatch/update';
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.showPruningCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
        } else {
          Axios.saveMaster(this.model)
            .then((response) => {
              this.showHideLoading();
              SweetAlert.success(response.data.message).then(() => {
                this.showPruningCatch = false;
                this.cleanForm();
              });
            })
            .catch((error) => {
              this.showHideLoading();
              this.showMessageErrors(error);
            });
          this.showHideLoading();
        }
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },
    confirmDelete() {
      if (this.model.pruning_catch_header_id) {
        SweetAlert.delete(
          i18n.t('sweet_alert.sowing.delete_pruning_catchs'),
          i18n.t('common_words.all_associated_records2')
        ).then((result) => {
          if (result.value) {
            this.deleteEradicateCatchs();
          }
        });
      } else this.cleanForm();
    },
    deleteEradicateCatchs() {
      if (this.isDelete()) {
        this.showHideLoading(true);
        this.model.route = 'pruning/pruningcatch/delete';
        this.model.id = this.model.pruning_catch_header_id;
        Axios.destroyMaster(this.model)
          .then((response) => {
            this.showPruningCatch = false;
            this.cleanForm();
            this.showHideLoading();
            this.showNotification(
              i18n.t(
                'show_notification.sowing.delete_pruning_catchs_successful'
              ),
              'success',
              'nc-simple-remove',
              `${i18n.t('common_words.successful_deletion')}...`
            );
          })
          .catch((error) => {
            this.showHideLoading();
            this.showMessageErrors(error);
          });
      } else {
        this.showMessageAccess();
      }
    },
    validateArea(index, lotId) {
      let lotArea = 0;
      for (let i = 0; i < this.model.nPruningCatchs; i++) {
        let lotSearch = this.lots.find((lot) => lot.id === lotId);
        if (isset(lotSearch)) {
          if (this.model.lots_ids[i] === lotId) {
            lotArea = lotArea + parseFloat(this.model.sown_area[i]);
            if (lotArea > lotSearch.area) {
              SweetAlert.warning(i18n.t('sweet_alert.sowing.error_lot_area'));
              this.$set(this.model.sown_area, index, null);
            }
          }
        }
      }
    },
  },
  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('farms/farms/only'),
        Axios.getMasters('cropvarieties'),
        Axios.getMasters('nursery/reasonrejection'),
      ]).then(
        ([responseFarm, responseCropVariety, responseReasonRejection]) => {
          this.farms = responseFarm.data.data;
          this.cropVarieties = responseCropVariety.data.data;
          let reasonRejections = responseReasonRejection.data.data;
          this.reasonRejections = reasonRejections.filter(
            (reasonRejection) => reasonRejection.type === 'Poda'
          );
          this.showHideLoading();
        }
      );
    } else {
      this.showHideLoading();
    }
  },
  mounted() {
    this.selectedItemOnMenu('pruning');
  },
  destroyed() {
    this.deselectedItemOnMenu('pruning');
  },
};
</script>
